
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-assessments",
      function () {
        return require("private-next-pages/ai-assessments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-assessments"])
      });
    }
  